type TeamsType = {
    children: any
}

export default function Teams({children}: TeamsType) {
    return (
        <div className="game-teams">{children}</div>
    )
}
